import * as React from "react";

export function Dialog({ open, onOpenChange, children }) {
  React.useEffect(() => {
    if (!open) return undefined;
    const handleKey = (event) => {
      if (event.key === "Escape") {
        onOpenChange?.(false);
      }
    };
    window.addEventListener("keydown", handleKey);
    return () => window.removeEventListener("keydown", handleKey);
  }, [open, onOpenChange]);

  if (!open) return null;

  return (
    <div
      className="fixed inset-0 z-50 flex items-center justify-center bg-black/40 px-4"
      onMouseDown={(event) => {
        if (event.target === event.currentTarget) {
          onOpenChange?.(false);
        }
      }}
    >
      {children}
    </div>
  );
}

export function DialogContent({ children, className = "", ...props }) {
  const {
    forceMount,
    onOpenAutoFocus,
    onCloseAutoFocus,
    ...rest
  } = props;
  void forceMount;
  void onOpenAutoFocus;
  void onCloseAutoFocus;
  return (
    <div
      role="dialog"
      aria-modal="true"
      className={`w-full max-w-lg rounded-2xl bg-white p-6 shadow-2xl ${className}`}
      {...rest}
    >
      {children}
    </div>
  );
}

export function DialogHeader({ children, className = "" }) {
  return <div className={`mb-4 ${className}`}>{children}</div>;
}

export function DialogTitle({ children, className = "" }) {
  return <h3 className={`text-xl font-semibold text-slate-900 ${className}`}>{children}</h3>;
}
